module.exports = __webpack_public_path__ + "static/img/tie.4770e79.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/tie.png
// module id = JWyi
// module chunks = 0